/* eslint-disable no-undef */
import { Controller } from "@hotwired/stimulus"

class ThemeSelect extends Controller {
  static targets = ["buttonLabel"]
  static values = {
    options: String,
  }

  connect() {
    this.options = JSON.parse(this.optionsValue)
  }

  onChange(event) {
    const value = event.target.value
    this.changeTheme(value)
    this.updateLabel(value)
  }

  changeTheme(value) {
    document.documentElement.setAttribute("class", `ctx-${value}-mode`)
  }

  updateLabel(value) {
    this.buttonLabelTarget.innerText = this.options[value]
  }
}

export { ThemeSelect }
